import React from "react";

import { useGetBenAdminRenewalQuery } from "BenAdminRenewal/redux";
import EmployerBreadcrumbs from "EmployerDashboard/Components/Breadcrumbs";
import { Link, RouteComponentProps } from "react-router-dom";

import Chrome from "../components/Chrome";
import Layout from "../components/Layout";
import { CardSection } from "Cobalt/Card";
import { Table, HeaderTR, TH, TR, TD } from "Cobalt/TableV2";
import DashboardHeader from "Common/DashboardHeader";
import Icon from "Common/Icon";
import BodyText from "Theme/BodyText";
import { LinkButton } from "Theme/Button";

const EmployeeEligibilityPage: React.FC<RouteComponentProps<{}>> = () => {
  const { isLoading: isLoadingBenAdminRenewal, data: benAdminRenewal } = useGetBenAdminRenewalQuery(null);
  const { employees } = benAdminRenewal;

  const title = "Confirm Employees";
  const crumbs = [
    { title: "Renewal", link: "/benefits-administration/renewal" },
    { title, link: "" },
  ];

  return (
    <Chrome title="SimplyInsured - Broker Dashboard">
      <Layout>
        <EmployerBreadcrumbs crumbs={crumbs} px={0} />
        <DashboardHeader title={title} subtitle="Confirm employees that are eligibile for benefits" px={0} />
        {isLoadingBenAdminRenewal ? (
          <BodyText>Loading...</BodyText>
        ) : (
          <CardSection px={0}>
            <BodyText>
              To change the eligibility status of the employees go to the <Link to="/employer-dashboard/manage-employees">Manage Employees</Link> page.
            </BodyText>
            <Table mt={4}>
              <thead>
                <HeaderTR>
                  <TH>Employee</TH>
                  <TH>Email</TH>
                  <TH align="left">Eligible</TH>
                </HeaderTR>
              </thead>
              <tbody>
                {employees.map(({ name, email, isEligible }, index) => (
                  <TR highlightFirstCell={false} key={index} withBorder={index !== employees.length - 1}>
                    <TD>{name}</TD>
                    <TD>{email}</TD>
                    <TD align="left">{isEligible ? <Icon ml={4} icon="check" /> : null}</TD>
                  </TR>
                ))}
              </tbody>
            </Table>
          </CardSection>
        )}
        <CardSection className="flex justify-between" px={0}>
          <LinkButton component={Link} size="medium" to="/benefits-administration/renewal/policy-details" color="link" pl={0}>
            <Icon icon="chevron-left" pr={3} />
            Back
          </LinkButton>
          <LinkButton component={Link} to="/benefits-administration/renewal/employee-contributions" size="medium">
            Next
          </LinkButton>
        </CardSection>
      </Layout>
    </Chrome>
  );
};

export default EmployeeEligibilityPage;
